import { Component, Input } from '@angular/core';
import { IFile } from '../../_entities';
import { FileBase } from './file-base';

@Component({
    selector: 'media-thumbnail',
    template: require('./media-thumbnail.component.html')
})
export class MediaThumbnailComponent extends FileBase  {
    constructor() { super(); }

    @Input() media: IFile;

}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/media-thumbnail.component.ts